import React from "react";

export const NotFound=()=>{
    return(
        <h1>Notfound</h1>
    )
}